module.exports = __webpack_public_path__ + "ce51c0d6740b99a72b64b9e40efc5aab.png";